import { computed } from 'mobx'
import { observer } from 'mobx-react'
import { getSnapshot } from 'mobx-state-tree'
import { Component } from 'react'

import { AutocompleteResult } from '../NetworkAutocomplete/NetworkAutocompleteOption'
import { INetworkListWithActionsItem, NetworkListWithActions } from '../NetworkAutocomplete/NetworkListWithActions'
import { IContactJSON, TContact } from './ContactsModel'

export interface IContactsActionListProps {
  contacts: (IContactJSON | TContact)[]
  removeContact: (_id: string) => void
}

export class LeanContactsActionList extends Component<IContactsActionListProps> {
  @computed
  get networkListWithActionItems(): INetworkListWithActionsItem[] {
    if (!this.props.contacts) {
      return []
    }
    return this.props.contacts.map((contact) => {
      let snapshot: IContactJSON
      try {
        snapshot = getSnapshot(contact) as IContactJSON
      } catch (ignoreError) {
        snapshot = contact as IContactJSON
      }
      return this.addActionToCompletion(this.formatContactToCompletion(snapshot), this.props.removeContact)
    })
  }

  addActionToCompletion(completion: AutocompleteResult, action: (_id: string) => void): INetworkListWithActionsItem {
    return { label: completion.label, _id: completion.value, onClickDelete: action }
  }

  formatContactToCompletion(contact: IContactJSON): AutocompleteResult {
    if (!contact) {
      // @ts-expect-error TS(2322) FIXME: Type 'undefined' is not assignable to type 'Autoco... Remove this comment to see the full error message
      return
    }
    return { label: `${contact.name} ${contact.email}`, value: contact._id, data: { entity: contact } }
  }

  render() {
    return <NetworkListWithActions items={this.networkListWithActionItems} />
  }
}

export const ContactsActionList = observer(LeanContactsActionList)
